import { IConfigData } from '@df/catalog/config/config.interfaces';
import { app } from '@df/core/app';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

export const CMS_CONFIG_PRODUCT_SALE_BANNER = 'product-sale-banner';

export const PRODUCT_SALE_BANNER_FIELDS = [
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'labels',
        title: 'Labels ',
        itemName: 'label',
        itemNameField: 'option',
        fields: [
            <NICmsContentField.IChoiceField>{
                key: 'option',
                required: true,
                type: NICmsContentField.EFieldType.choice,
                title: 'Option',
                options: () =>
                    app.resources.attribute
                        .get('sale_banner')
                        ?.data?.options?.map(option => ({ key: option.value, title: option.label })) || []
            },
            <NICmsContentField.IDatetimeField>{
                key: 'endDate',
                type: NICmsContentField.EFieldType.datetime,
                title: 'End date',
                required: true
            },
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.text,
                key: 'copy',
                title: 'Copy',
                default: 'ENDS in'
            },
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.toggle,
                key: 'enable',
                title: 'Enable',
                default: true
            }
        ]
    }
];

export interface IICmsConfigProductSaleBannerDataContent {
    labels: ILables[];
}

export type IICmsConfigProductSaleBannerData = IConfigData<IICmsConfigProductSaleBannerDataContent>;

export interface ILables {
    option: number;
    endDate: Date;
    copy?: string;
    enable?: boolean;
}

ICmsContentService.registerConfig({
    id: CMS_CONFIG_PRODUCT_SALE_BANNER,
    name: 'Product Sale Banner',
    fields: PRODUCT_SALE_BANNER_FIELDS
});
